import { useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import API, { removeAuthToken } from '@/helpers/API';
import { postLogout } from '@/helpers/Requester';
import { ModalService as modal } from '@/libs/Modal';

const useAuth = () => {
  const navigate = useNavigate();
  const store = useStore();

  // 로그인
  const doLogin = async (userInfo) => {
    const { success, data } = await API.post('/auth/login', userInfo);
    if (!success) throw new Error();

    return data;
  };

  // 티켓 로그인
  const doLoginWithTicket = async (ticket) => {
    const { success, data } = await API.post('/auth/login/ticket', { ticket });
    if (!success) throw new Error();

    return data;
  };

  // 로그아웃
  const doLogout = () => {
    postLogout();
    removeAuthToken();
    navigate('/', { replace: true });

    // 리듀서 상태 초기화
    store.resetAll();

    modal.hide();
  };

  return {
    doLogin,
    doLoginWithTicket,
    doLogout,
  };
};

export default useAuth;
